import CusAvatar from "./CusAvatar";

export default CusAvatar;